import React from "react";
import { BrowserRouter, Route, Link } from "react-router-dom";
import { MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, MDBRow, MDBCol, MDBBtn, MDBContainer, MDBSelect } from "mdbreact";

import Upload from "../Upload/Upload";


import DatePicker,{registerLocale,setDefaultLocale} from "react-datepicker";
import ja from 'date-fns/locale/ja';

import "react-datepicker/dist/react-datepicker.css";
import "./Report.css";

import firebase from "../../firebase"
import {toast} from "react-toastify";

registerLocale('ja', ja);
setDefaultLocale('ja')

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reportNum: '',
      startDate: new Date(),
      title: '',
      titlekana: '',
      toUser: '',
      toUserCC: [],
      toUserCCName: [],
      userList: [],
      files: [],
      modal: false,
      errModal: false,
      regModal: false
    }
  }

  handleChange = date => {
    this.setState({
      startDate: date
    });
  };

  handleNumChange = (e) => {
    this.setState({
      reportNum: e.currentTarget.value
    });
  }

  handleTitleChange = (e) => {
    this.setState({
      title: e.currentTarget.value
    });
  }
  handleTitleKanaChange = (e) => {
    this.setState({
      titlekana: e.currentTarget.value
    });
  }

  handleToUserChange = (e) => {
    if (e.currentTarget.selectedIndex > 0) {
      this.setState({
        toUserName: e.currentTarget.options[e.currentTarget.selectedIndex].dataset.name,
        toUser: e.currentTarget.value
      }, () => {
        this.setUserList();
      });
    } else {
      this.setState({
        toUserName: '',
        toUser: ''
      }, () => {
        this.setUserList();
      });
    }
  }

  handleToUserCCChange = (e) => {
    let toUserCCName = e.map(userId => {
      return (this.props.org.users.find(data => data.user === userId) || {}).name;
    }) || [];

    this.setState({
      toUserCC: e,
      toUserCCName: toUserCCName
    })
  }

  selectPersonAlert = () => {
    toast.warning("相手先営業担当者を先に選択してください。", {
      position: toast.POSITION.TOP_RIGHT
    });
  }

  modalClose = () => {
    this.setState({
      modal: false,
      title: '',
      toUser: '',
      files: [],
    })
    this.refs.UploadComponent.resetFile();
  }
  errModalClose = () => {
    this.setState({
      errModal: false
    })
  }

  reportRegister = (e) => {
    e.preventDefault();
    this.setState({
      regModal: true
    })
  }

  regModalClose = (e) => {
    this.setState({
      regModal: false
    })

    let esConfirm = e.currentTarget.dataset.confirm;
    if (esConfirm) {
      this.fileUpload(e);
    }
  }

  fileUpload = (e) => {
    e.preventDefault();

    // console.log("fileUpload",e);
    // console.log(this.state.files[0]);


    if(this.state.files.length > 0){
      const file = this.state.files[0];

      //this.props.storage.refFromURL(this.props.src);
      // console.log(file.name);

      var fileRef = this.props.storage.ref().child('report/' + '/' + this.props.user.id + '/' + this.props.org.id + file.name);

      fileRef.getDownloadURL().then((onResolve) => {
        console.log("Same File Exist");
        this.setState({
          errModal: true,
        })
      }, (onReject) => {
        console.log(fileRef.bucket);
        console.log(fileRef.fullPath);

        fileRef.put(file).then(function(snapshot) {
          console.log('Uploaded a blob or file!');
        });
        this.dataSet(fileRef);

      });
    }
  }

  dataSet = (snapshot) => {

    // console.log("dataSet");
    // console.log(this.state.startDate);
    // console.log(this.state.startDate2);

    let reportRef = this.props.db.collection('report').doc();
    let dueDate = new Date(this.state.startDate);

    let setWithMerge = reportRef.set({
      number: this.state.reportNum,
      title: this.state.title,
      titlekana: this.state.titlekana,
      date: firebase.firestore.Timestamp.fromDate(this.state.startDate),
      dueDate: dueDate.getTime(),
      fromUser: this.props.user.id,
      fromUserName: this.props.user.last_name + this.props.user.first_name,
      fromOrganization: this.props.userOrg?.id,
      toUser: this.state.toUser,
      toUserName: this.state.toUserName,
      toUserCC: this.state.toUserCC,
      toUserCCName: this.state.toUserCCName,
      toOrganization: this.props.org.id,
      deleted: false,
      readBuyer: false,
      readSeller: false,
      created: firebase.firestore.Timestamp.fromDate(new Date()),
      file: snapshot.fullPath,
    }, { merge: true });
    this.setState({
      modal: true,
    })
  }

  componentDidMount() {
    if (this.props.org) {
      this.setUserList();
    }
  }

  setUserList = () => {
    let toUserCC = this.state.toUserCC;
    let toUserCCName = this.state.toUserCCName;
    let toUser = this.state.toUser;
    let toUserName = this.state.toUserName;
    let userList = this.props.org.users.map((user) => {
      let found = false;
      for (let i=0; i<toUserCC.length; i++) {
        if (toUserCC[i] === user.user) {
          found = true;
        }
      }

      if (found) {
        return {value: user.user, text: user.name, checked: true}
      } else {
        return {value: user.user, text: user.name}
      }
    });

    toUserCC = toUserCC.filter(v => v !== toUser);
    toUserCCName = toUserCCName.filter(v => v!== toUserName);

    userList = userList.filter(v => v.value !== toUser);
    this.setState({userList, toUserCC, toUserCCName});
  }

  onFilesAdded = (files) => {
    this.setState({
      files: files
    });
    console.log(files);
  }

  handleInputChange = inputName => value => {
    const nextValue = value;
    this.setState({
        [inputName]: nextValue
    });
  };

  render() {
    if (! this.props.org ) {
      return (
        <>
          取引先を選択してください。
        </>
      )
    }

    const isEnable = (this.state.files.length > 0)
        && (this.state.reportNum !== '')
    && (this.state.startDate !== '')
    && (this.state.title !== '')
    // && (this.state.titlekana !== '')
        && (this.state.toUser !== '')

    if ( (this.props.userOrg && this.props.userOrg.reseller)
      || (this.props.userOrg && this.props.userOrg.maker)
    ){
    }else{
      return (
        <>
        </>
      )
    }

    return (
      <>
      <MDBContainer>
        <MDBRow>
          <MDBCol md="12" className="mb-3">
            <h2>報告書登録</h2>
            <form>
              <div style={{display: 'flex', alignItems: 'center'}}>
              <label htmlFor="reportNum" className="grey-text">
                報告書番号
              </label>
                &nbsp;
                <span className={'cart-require'} style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
              </div>
              <input
                  type="text"
                  id="reportNum"
                  className="form-control"
                  name="reportNum"
                  onChange={this.handleNumChange}
                  value={this.state.reportNum}
              />
              <br />
              <div style={{display: 'flex', alignItems: 'center'}}>
            <label htmlFor="reportDate" className="grey-text">
              発行日付指定
            </label>
              &nbsp;
              <span className={'cart-require'} style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
            </div>
            <DatePicker
              dateFormat="yyyy/MM/dd"
              id="reportDate"
              className="form-control"
              selected={this.state.startDate}
              onChange={this.handleChange}
              locale="ja-JP"
            />
            <br />
              <div style={{display: 'flex', alignItems: 'center'}}>
            <label htmlFor="reportTitle" className="grey-text">
              報告書タイトル
            </label>
              &nbsp;
              <span className={'cart-require'} style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
            </div>
            <input
              type="text"
              id="reportTitle"
              className="form-control"
              name="title"
              onChange={this.handleTitleChange}
              value={this.state.title}
            />
            <br />
              <div style={{display: 'flex', alignItems: 'center'}}>
            <label htmlFor="reportTitleKana" className="grey-text">
              報告書タイトル（ふりがな）
            </label>
                &nbsp;
                <span className={'cart-require-any'} style={{marginBottom: '0.5rem', marginTop: 0}}>任意</span>
            </div>
            <input
              type="text"
              id="reportTitleKana"
              className="form-control"
              name="title"
              onChange={this.handleTitleKanaChange}
              value={this.state.titlekana}
            />
            <br />
              <div style={{display: 'flex', alignItems: 'center'}}>
              <label htmlFor="estimates2ToUser" className="grey-text">
                相手先担当者選択
              </label>
              &nbsp;
              <span className={'cart-require'} style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
            </div>
              <select
                  className="browser-default custom-select"
                  id="estimates2ToUser"
                  onChange={this.handleToUserChange}
                  value={this.state.toUser}
              >
                <option>選択してください</option>
                {this.props.org && this.props.org.users &&
                    this.props.org.users.map((user) =>
                        <option key={user.user} value={user.user} data-name={user.name}>{user.name}</option>
                    )
                }
              </select>
              <br />

              <div style={{position: 'relative'}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                <label htmlFor="estimateToUserCC" className="grey-text">
                  相手先CC選択（複数選択可）
                </label>
                  &nbsp;
                  <span className={'cart-require-any'} style={{marginBottom: '0.5rem', marginTop: 0}}>任意</span>
                </div>
                <MDBSelect disabled={true} id={'estimateToUserCC'} className={'cart-select custom-select'} options={this.state.userList} getValue={this.handleToUserCCChange} multiple={true}/>
                {!this.state.toUser && <div style={{width: '100%', height: '100%', position: 'absolute', left: 0, top: 0, cursor: 'pointer'}} onClick={() => this.selectPersonAlert()}/>}
              </div>
              <br/>

            <label htmlFor="reportFile" className="grey-text">
              報告書 PDF選択
            </label>
            <Upload onFilesAdded={this.onFilesAdded} ref="UploadComponent" />

            {false &&
            <div className="input-group">
              <div className="custom-file">
                <input
                  type="file"
                  className="custom-file-input"
                  id="reportFile"
                  aria-describedby="inputGroupFileAddon01"
                />
                <label className="custom-file-label" htmlFor="inputGroupFile01">
                  ファイルを選択してください
                </label>
              </div>
            </div>
            }


            <div className="text-center mt-4">
              <MDBBtn
                color="default"
                type="submit"
                disabled={!isEnable}
                onClick={this.reportRegister}
              >新規報告書登録</MDBBtn>
            </div>
          </form>

          </MDBCol>
        </MDBRow>

        <MDBModal isOpen={this.state.regModal} toggle={this.regModalClose}>
          <MDBModalHeader toggle={this.regModalClose}>請求書登録</MDBModalHeader>
          <MDBModalBody>
            報告書を登録します。よろしいですか？
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn onClick={this.regModalClose} color="secondary">キャンセル</MDBBtn>
            <MDBBtn onClick={this.regModalClose} data-confirm={true}>登録</MDBBtn>
          </MDBModalFooter>
        </MDBModal>

        <MDBModal isOpen={this.state.modal} toggle={this.modalClose}>
          <MDBModalHeader toggle={this.modalClose}>登録完了</MDBModalHeader>
          <MDBModalBody>
            報告書を登録しました
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn onClick={this.modalClose}>確認</MDBBtn>
          </MDBModalFooter>
        </MDBModal>

        <MDBModal isOpen={this.state.errModal} toggle={this.errModalClose}>
          <MDBModalHeader className="warning-color-dark white-text" toggle={this.errModalClose}>重複確認</MDBModalHeader>
          <MDBModalBody>
            同名の報告書が存在するので処理を中止しました。
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="orange darken-3" onClick={this.errModalClose}>確認</MDBBtn>
          </MDBModalFooter>
        </MDBModal>


      </MDBContainer>
      </>
    )
  }
}
export default Report;

